export default {
  id: '0fdb06be26',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page static-content-page" data-name="about">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div class="title">About mDOC</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="static-hero">\n                <div class="static-hero-logo">\n                    <img src="static/img/mdoc-logo.svg" alt="mDOC">\n                </div>\n                <div class="static-hero-title">About mDOC</div>\n                <div class="static-hero-sub">Online doctor appointments, lab tests, and care plans.</div>\n            </div>\n            <div class="static-content-card">\n                <p>';
      r += c(ctx_1.data, ctx_1);
      r += '</p>\n            </div>\n            <div class="static-content-spacer"></div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};